export default "__VITE_ASSET__CkYhW66g__"